import React from 'react';
import './InstitutionSection.css';

const InstitutionSection = () => {
  const features = [
    {
      title: 'Fully White-Labelled Dashboard',
      description: 'Professionalled dashboard to our af college institutions'
    },
    {
      title: 'Enhance Student Outcomes',
      description: 'Ennzances student prevents and domir-otatisn eodicotes'
    },
    {
      title: 'Admin-Controlled Access',
      description: 'Provide-rantasy yetards with admin-controlled access'
    }
  ];

  return (
    <section className="section institution-section">
      <div className="container">
        <h2 className="section-title">Institution Offering (B2B)</h2>

        <div className="institution-content">
          <div className="institution-mockup">
            <div className="mockup-window">
              <div className="mockup-header">
                <span className="mockup-logo">12thplus.com</span>
                <div className="mockup-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div className="mockup-body">
                <div className="mockup-sidebar">
                  <div className="mockup-menu-item"></div>
                  <div className="mockup-menu-item active"></div>
                  <div className="mockup-menu-item"></div>
                </div>
                <div className="mockup-main">
                  <div className="mockup-title-bar">
                    <span>School Dashboard</span>
                    <div className="mockup-stats">
                      <span className="stat">640</span>
                      <span className="stat">CATE</span>
                      <span className="stat">32</span>
                    </div>
                  </div>
                  <div className="mockup-chart"></div>
                </div>
              </div>
              <div className="powered-badge">
                <span>Powered by</span>
                <span className="badge-brand">12th<span className="plus">plus</span>.com</span>
              </div>
            </div>
          </div>

          <div className="institution-features">
            {features.map((feature, index) => (
              <div key={index} className="institution-feature">
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InstitutionSection;
